import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MicroLabel = styled(Typography)(({ theme }) => ({
  display: 'block',
  color: theme.palette.text.secondary,
  fontSize: '0.65rem',
  fontWeight: theme.typography.fontWeightSemiBold,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  opacity: 0.8,
}));
